import { render, staticRenderFns } from "./emailTemplates.vue?vue&type=template&id=c32d3e70&scoped=true"
import script from "./emailTemplates.vue?vue&type=script&lang=js"
export * from "./emailTemplates.vue?vue&type=script&lang=js"
import style0 from "./emailTemplates.vue?vue&type=style&index=0&id=c32d3e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32d3e70",
  null
  
)

export default component.exports